/**
 * URL share helpers. Encodes the full form state into a URL hash
 * so a board can be shared without server persistence.
 *
 * Format: #b=<base64url(JSON)>
 */

function toBase64Url(str) {
  const b64 = btoa(unescape(encodeURIComponent(str)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function fromBase64Url(b64url) {
  const pad = b64url.length % 4 === 0 ? "" : "=".repeat(4 - (b64url.length % 4));
  const b64 = b64url.replace(/-/g, "+").replace(/_/g, "/") + pad;
  return decodeURIComponent(escape(atob(b64)));
}

export function encodeBoardToUrl(form, mode) {
  try {
    const payload = JSON.stringify({ ...form, mode });
    const encoded = toBase64Url(payload);
    const url = new URL(window.location.href);
    url.hash = `b=${encoded}`;
    return url.toString();
  } catch {
    return window.location.href;
  }
}

export function decodeBoardFromUrl() {
  try {
    const hash = window.location.hash || "";
    const m = hash.match(/(?:^#|&)b=([A-Za-z0-9_-]+)/);
    if (!m) return null;
    return JSON.parse(fromBase64Url(m[1]));
  } catch {
    return null;
  }
}

export function clearBoardUrlHash() {
  if (window.location.hash) {
    history.replaceState(null, "", window.location.pathname + window.location.search);
  }
}
